import { ArrowLeft, ArrowRight, Loader2 } from 'lucide-react';

interface StepNavigationProps {
  currentStep: number;
  totalSteps: number;
  isSubmitting: boolean;
  onBack: () => void;
  onCancel: () => void;
}

export function StepNavigation({
  currentStep,
  totalSteps,
  isSubmitting,
  onBack,
  onCancel
}: StepNavigationProps) {
  return (
    <div className="px-6 py-4 bg-slate-50 border-t border-slate-100 flex justify-between">
      <div>
        {currentStep > 1 ? (
          <button type="button" onClick={onBack} className="btn-secondary">
            <ArrowLeft className="w-4 h-4" />
            Back
          </button>
        ) : (
          <button type="button" onClick={onCancel} className="btn-secondary">
            Cancel
          </button>
        )}
      </div>
      <button type="submit" disabled={isSubmitting} className="btn-primary">
        {isSubmitting ? (
          <>
            <Loader2 className="w-4 h-4 animate-spin" />
            Saving...
          </>
        ) : currentStep < totalSteps ? (
          <>
            Next Step
            <ArrowRight className="w-4 h-4" />
          </>
        ) : (
          'Create Quotation'
        )}
      </button>
    </div>
  );
}
